import React from "react";
import { TypeOf } from 'zod';
import {Save} from "@mui/icons-material";
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {Button, Stack, Box, Badge,} from "@mui/material";
import useEntity from "../../../hooks/useProvider";
import {PrimaryProvider} from "../../../types/models/Provider";
import {useGetProviderQuery} from "../../../apis/Provider.api";
import ProviderUpdateForm, {formSchema, initialFormStateFn} from "../../../components/provider/ProviderForm/ProviderUpdateForm";
import { Trans } from "@lingui/react/macro";

export type FormInput = TypeOf<typeof formSchema>;

const ProviderUpdateFormProvider = ({ id, initialFormState, cancelButton = undefined, redirectPath = undefined, successAction = undefined }) => {

    const primary = PrimaryProvider.fromPath(id);
    const { data, isLoading } = useGetProviderQuery(primary)

    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: initialFormState(data)
    });
    const {  updateProvider } = useEntity();

    const {
        watch,
        reset,
        handleSubmit,
        formState: { isSubmitSuccessful, errors, },
    } = methods;

    React.useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data, reset]);

    
    const onSubmitHandler: SubmitHandler<FormInput> = async (values) => {
        const data = await updateProvider({
            id: primary,
            data: values,
        }, redirectPath)
        if (data && successAction) {
            successAction(data)
        }
    };

    return (
        <>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={
                        (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleSubmit(onSubmitHandler)(e)
                        }
                    }
                    noValidate
                >

                    <ProviderUpdateForm watch={watch}/>

                    <Stack direction="row" justifyContent="end" spacing={1} padding={5}>

                        { cancelButton }

                        
                        <Badge badgeContent={Object.values(errors).length} color="error" anchorOrigin={ {vertical: 'bottom'} }>
                            <Button size="medium" variant="contained" color="primary" type='submit' startIcon={<Save />}>
                                <Trans>Update</Trans>
                            </Button>
                        </Badge>
                    </Stack>
                </Box>
            </FormProvider>
        </>
    )
}

export default ProviderUpdateFormProvider
